import { Link } from 'react-router-dom'

import Button from './design/Button'
import Heading from './design/Heading'
import Paragraph from './design/Paragraph'

type Props = {
    resetErrorBoundary: (...args: Array<unknown>) => void
}

const ErrorRecordNotFound = ({ resetErrorBoundary }: Props) => {
    return (
        <div className="flex h-screen flex-col items-center justify-center">
            <Heading size="xl" className="mb-4">
                Record Not Found
            </Heading>
            <Paragraph className="mb-8">
                Sorry, we couldn't find the record you're looking for.
            </Paragraph>
            <Link to="/">
                <Button intent="primary" onClick={resetErrorBoundary}>
                    Go Home
                </Button>
            </Link>
        </div>
    )
}

export default ErrorRecordNotFound
